import { SvgIcon } from '@mui/material';

const DotIcon = (props) => (
    <SvgIcon viewBox="0 0 10 10" {...props}>
        <circle cx="5" cy="5" r="5" fill="currentColor" />
    </SvgIcon>
);

export default DotIcon;